export default {
	welcome_back: 'Welcome back',
	enter_email_password: 'Enter your email and password to sign in',
	username: 'Username',
	password: 'Password',
	remember_me: 'Remember me',
	no_account_sign_up: "Don't have an account?",
	sign_up: 'Sign up',
	company: 'Company',
	about_us: 'About Us',
	team: 'Team',
	products: 'Products',
	blog: 'Blog',
	pricing: 'Pricing',
	copyright: 'Copyright © 2024 EquiUp.',
	sign_in: 'Sign in',
	error_wrong_username: 'User name or password is wrong.',
	operation_saved: 'horse is saved.',
	members: 'Members',
	member: 'Member',
	first_name: 'Name',
	last_name: 'Last name',
	profession: 'Profession',
	email: 'Email',
	location: 'Location',
	phone_number: 'Phone number',
	photo_url: 'Photo URL',
	first_last_name: 'FirstName LastName',
	card: 'Card number',
	expires_at: 'Expiration date',
	edit: 'Edit',
	delete: 'Delete',
	add: 'Add',
	irreversible_action: "Irreversible action",
	do_u_confirm: "Do you confirm?"
};
